<template>
  <div>
    <Range :type="simulationStore.TYPE_LIVING"></Range>
   
  </div>
</template>
<script setup lang="ts">
import {ref} from "vue";
import Range from "./Range.vue";

import {useSimulationStore} from "../../stores/simulation";
const simulationStore = useSimulationStore();
const childTypes = simulationStore.getLivingChildTypes();

</script>